import { render } from "./HomeRoot.vue?vue&type=template&id=af1390b8"
import script from "./HomeRoot.vue?vue&type=script&lang=js"
export * from "./HomeRoot.vue?vue&type=script&lang=js"

import "./HomeRoot.vue?vue&type=style&index=0&id=af1390b8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__